import type { User } from '../hooks/useAuth';

/** Where `/` sends a user: an admin stays on Home, the reviewer role opens the audit page, every other role Documents. */
export const homeRedirect = (user: User | null): string | undefined => {
  if (user?.role === 'admin') return undefined;
  if (user?.role === 'supervisor') return '/supervisor/audit';
  return '/documents';
};
